<div class="stroked-btn btn-with-theme" [ngClass]="theme">
    <button mat-stroked-button class="btn"
    [type]="type" 
    [ngClass]="{'uc': uppercase, 'primary-color': color == 'primary'}" 
    [color]="color" 
    [disabled]="disabled" 
    [ngStyle]="{'fontWeight': fontWeight}"
    >{{text}}</button>
</div>
